import * as React from 'react';
import { DefaultLayout } from '../../components/DefaultLayout';
import { Seo } from "../../components/Seo";

import { YandexMetrika } from '../../components/YandexMetrika';
import { MailRu } from '../../components/MailRu';
import { TikTok } from '../../components/TikTok';
import { VKPixel } from '../../components/VKPixel';
import { AdvCake } from '../../components/AdvCake';

import { HeaderLogoAndTel } from "../../components/HeaderLogoAndTel";
import { FooterFull } from "../../components/FooterFull";
import { TextReviews } from "../../components/TextReviews";
import { Modal } from "../../components/Modal";

import * as main from "./styles/main.module.scss";
import * as screen1 from "./styles/screen1.module.scss";
import * as advantages from "./styles/advantages.module.scss";
import * as how from "./styles/how.module.scss";
import * as match from "./styles/match.module.scss";
import * as reviews from "./styles/reviews.module.scss";
import * as calc from "./styles/calc.module.scss";
import * as support from "./styles/support.module.scss";
import dataReviews from "./data/textReviews.json";
import {GetCourseWidget} from "../../components/GetCourseWidget";
const Screen1 = ({ widget }) => {
  const [showModal, setShowModal] = React.useState(false);
  return (
    <header className={screen1.screen1}>
      <div className="container">

        <HeaderLogoAndTel padding={"30px 0 10px"}/>

        <div className={screen1.wrapper}>
          <div className={screen1.info}>
            <h1>Начни зарабатывать вместе с Advance</h1>
            <p>Подключайся к партнёрской программе Advance и зарабатывай от 25% стоимости каждого курса</p>
            <button className={main.btn} onClick={()=>{setShowModal(true)}}>Присоединиться</button>
          </div>
          <img src="https://fs.advance.ru/landing-pages/partners/partner_new/_screen1/mainAZ-rocket.png" alt={""}/>
        </div>
      </div>

      <Modal
        open={showModal}
        onClose={() => {
          setShowModal(false);
        }}
      >
        { widget }
      </Modal>
    </header>
  );
};
const Advantages = () => {
  return (
    <section className={advantages.advantages}>
      <div className="container">
        <h2 className={main.title}>Почему именно мы?</h2>
        <p className={advantages.sub}>Закрепляем за вами пользователей на год и выплачиваем комиссию за все покупки в этот период</p>
        <ul>
          <li>
            <img src="https://fs.advance.ru/landing-pages/partners/partner_new/_advantages/icon-why-00-1.svg" alt={""}/>
            <p>Средний чек —<br/>от 25 000 до 75 000 рублей в зависимости от направления</p>
          </li>
          <li>
            <img src="https://fs.advance.ru/landing-pages/partners/partner_new/_advantages/icon-why-00-2.svg" alt={""}/>
            <p>CTR = 1,8–3,2 %</p>
          </li>
          <li>
            <img src="https://fs.advance.ru/landing-pages/partners/partner_new/_advantages/icon-why-00-3.svg" alt={""}/>
            <p>Доходимость<br/>на бесплатное мероприятие — 39 %</p>
          </li>
          <li>
            <img src="https://fs.advance.ru/landing-pages/partners/partner_new/_advantages/icon-why-02.svg" alt={""}/>
            <p>Отличная конверсия — аналогов наших продуктов нет</p>
          </li>
          <li>
            <img src="https://fs.advance.ru/landing-pages/partners/partner_new/_advantages/icon-why-03.svg" alt={""}/>
            <p>Высокий доход: средний заработок партнёров — 80 000 рублей</p>
          </li>
          <li>
            <img src="https://fs.advance.ru/landing-pages/partners/partner_new/_advantages/icon-why-04.svg" alt={""}/>
            <p>Полностью прозрачная статистика в режиме реального времени</p>
          </li>
          <li>
            <img src="https://fs.advance.ru/landing-pages/partners/partner_new/_advantages/icon-why-05.svg" alt={""}/>
            <p>Оперативная обратная связь — у вас будет персональный менеджер</p>
          </li>
          <li>
            <img src="https://fs.advance.ru/landing-pages/partners/partner_new/_advantages/icon-why-06.svg" alt={""}/>
            <p>Удобные ежемесячные выплаты — как для физических, так и для юридических лиц</p>
          </li>
          <li>
            <img src="https://fs.advance.ru/landing-pages/partners/partner_new/_advantages/icon-why-07.svg" alt={""}/>
            <p>Помощь и мотивация с нашей стороны: повышение ставок, рекламные материалы, акции и промокоды</p>
          </li>
        </ul>
      </div>
    </section>
  );
};
const How = ({ widget }) => {
  const [showModal, setShowModal] = React.useState(false);
  return (
    <section className={how.how}>
      <div className="container">
        <div className={how.wrapper}>
          <h2 className={main.title}>Как работает партнёрская программа</h2>
          <div className={how.steps}>
            <ol>
              <li>
                <span>1</span>
                <p>Вы регистрируетесь в партнёрской программе.</p>
              </li>
              <li>
                <span>2</span>
                <p>Получаете партнёрский код.</p>
              </li>
              <li>
                <span>3</span>
                <p>Забираете свою партнёрскую ссылку.</p>
              </li>
              <li>
                <span>4</span>
                <p>Размещаете ссылку на своём сайте, в социальных сетях, в рекламных объявлениях и т. д.</p>
              </li>
              <li>
                <span>5</span>
                <p>Пользователи переходят по ссылке и покупают наши продукты.</p>
              </li>
              <li>
                <span>6</span>
                <p>Вы получаете комиссию от стоимости продукта.</p>
              </li>
            </ol>
            <button className={main.btn} onClick={()=>{setShowModal(true)}}>Зарегистрироваться</button>
          </div>
        </div>
      </div>

      <Modal
        open={showModal}
        onClose={() => {
          setShowModal(false);
        }}
      >
        { widget }
      </Modal>
    </section>
  );
};
const Match = () => {
  return (
    <section className={match.match}>
      <div className="container">
        <h2 className={main.title}>Кому подходит партнёрская программа</h2>
        <ul>
          <li>
            <img src="https://fs.advance.ru/landing-pages/partners/partner_new/_match/icon-who-01.svg" alt={""}/>
              <h3>Веб-мастерам</h3>
              <p>У вас есть посещаемый онлайн-ресурс: блог, портал, каталог, сервис?</p>
              <p>Размещайте баннеры, статьи и ссылки на нас</p>
          </li>
          <li>
            <img src="https://fs.advance.ru/landing-pages/partners/partner_new/_match/icon-who-02.svg" alt={""}/>
              <h3>Блогерам</h3>
              <p>Развиваете свой блог, канал или сообщество в социальных сетях?</p>
              <p>Рассказывайте о нас в выпусках и постах</p>
          </li>
          <li>
            <img src="https://fs.advance.ru/landing-pages/partners/partner_new/_match/icon-who-03.svg" alt={""}/>
              <h3>Арбитражникам и рекламным агентствам</h3>
              <p>Знаете, как закупать трафик на EdTech, или хотели бы попробовать вертикаль?</p>
              <p>Добро пожаловать!</p>
          </li>
          <li>
            <img src="https://fs.advance.ru/landing-pages/partners/partner_new/_match/icon-who-04.svg" alt={""}/>
              <h3>Всем, кто хочет и умеет зарабатывать,</h3>
              <p>продвигая образовательные продукты</p>
          </li>
        </ul>
      </div>
    </section>
  );
};
const Reviews = () => {
  return (
    <section className={reviews.reviews}>
      <div className="container">
        <h2 className={main.title}>Отзывы партнёров</h2>
        <TextReviews data={dataReviews} buttonsColor={"#9C87D9"}/>
      </div>
    </section>
  );
};
const Calc = ({ widget }) => {
  const [showModal, setShowModal] = React.useState(false);
  const [valueToTextInput, setValueToTextInput] = React.useState(1);
  const [valueOfRange, setValueOfRange] = React.useState(49900);
  const handleInputChange = (e) => {
    if (e.target.value > 0) {
      setValueToTextInput(+(e.target.value))
    } else {
      setValueToTextInput('');
    }
  }
  const handleMinusBtn = () => {
    valueToTextInput > 0 ? setValueToTextInput(valueToTextInput-1) : setValueToTextInput(0)
  };
  const handlePlusBtn = () => {
    setValueToTextInput(valueToTextInput+1)
  };
  const handleRangeChange = (e) => {
    setValueOfRange(e.target.value)
  };
  const calculateRewardSum = (check, order) => {
    const partnerPercent = 25;
    return (check * partnerPercent / 100) * order;
  };
  return (
    <section className={calc.calc}>
      <div className="container">
        <h2 className={main.title}>Спрогнозируйте свой доход от рекламы</h2>
        <p className={calc.sub}>Приблизительные данные, рассчитанные на основе агрегированной партнёрской статистики</p>
        <div className={calc.wrapper}>
          <img src="https://fs.advance.ru/landing-pages/partners/partner_new/_calc/calculator.svg" alt={""}/>
          <div className={calc.calculator}>
            <div className={calc.orders}>
              <h3>Число подтверждённых заказов</h3>
              <div className={calc.inner}>
                <button className={calc.minus} onClick={handleMinusBtn}>-</button>
                <input value={valueToTextInput} type="number" className={calc.input} min="0" onChange={handleInputChange}/>
                <button className={calc.plus} onClick={handlePlusBtn}>+</button>
              </div>
            </div>
            <div className={calc.check}>
              <h3>Средний чек</h3>

              <input value={valueOfRange || 49900} type="range" min="900" max="189900" step="1000" id="range" className={calc.range} onChange={handleRangeChange}/>

              <span className={calc.min}>990 ₽</span>
              <span className={calc.max}>189 900 ₽</span>

              <p className={calc.rangevalue}>{`${valueOfRange} ₽`}</p>

            </div>
            <div className={calc.reward}>
              <h3>Ваше вознаграждение с одной продажи:</h3>

              <p className={calc.sum}>{`${calculateRewardSum(valueOfRange, valueToTextInput) || 0} ₽`}</p>

            </div>
            <button className={`${main.btn} ${calc.btn}`} onClick={()=>{setShowModal(true)}}>Начать зарабатывать</button>
          </div>
        </div>
      </div>

      <Modal
        open={showModal}
        onClose={() => {
          setShowModal(false);
        }}
      >
        { widget }
      </Modal>
    </section>
  );
};
const Support = () => {
  return (
    <section className={support.support}>
      <div className="container">
        <h2 className={main.title}>Остались вопросы?</h2>
        <p className={support.subtitle}>
          С подробными условиями партнёрской программы вы можете ознакомиться
          <a href="https://fs.advance.ru/landing-pages/files/partner_oferta.pdf" target="_blank" rel={"noreferrer"}> в оферте</a>.
        </p>
        <div className={support.info}>
          <p>Свяжитесь с нашим менеджером в телеграме
            <a href="https://t.me/for_partners_advance" target="_blank" rel={"noreferrer"}> @for_partners_advance</a> или по почте
            <a href="mailto:partners@advance.ru"> partners@advance.ru</a>
          </p>
          <img src="https://fs.advance.ru/landing-pages/partners/partner_new/_support/support.svg" alt={""}/>
        </div>
      </div>
    </section>
  );
};

const TITLE = 'Партнерская программа центра образовательных технологий «Advance»';
const DESCRIPTION = 'Стать партнером центра образовательных технологий «Advance». Среди основных направлений нашей деятельности – развитие памяти, методы эффективной работы с информацией, изучение иностранных языков с нуля за 3 месяца';
export const Head = () => (
  <Seo title={TITLE} description={DESCRIPTION}>
    <title>{TITLE}</title>
  </Seo>
);
const Page = ({ widget=<GetCourseWidget hash={'0637dfbbad390026c7f7aa6a0a0103ef5028f20c'} id={'314310'}/> }) => (
  <DefaultLayout>

    <YandexMetrika />
    <MailRu />
    <TikTok />
    <VKPixel />
    <AdvCake />

    <main>
      <Screen1 widget={widget}/>
      <Advantages/>
      <How widget={widget}/>
      <Match/>
      <Reviews/>
      <Calc widget={widget}/>
      <Support/>
    </main>

    <FooterFull/>
  </DefaultLayout>
);
export default Page;
